import { fabric } from "fabric";
import { isEmpty } from "lodash";
import axios from "axios";
import moment from "moment";
import reduxStore from "../configureEnvStore";

import { AR_MARKUP_VIEW, ENABLED, EXTRACT_TEXT_VIEW, MARKUP_VIEW, MEASUREMENT_VIEW, OCR_API_URL } from "../constants/Constants";
import { NOTIFICATION_TYPES } from "../constants/DataTrackNotificationConstants";
import { EVENT_NAME } from "../constants/GTagConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import Localize from "../locale/Localize";
import { STATUS } from "../constants/LivePointerConstants";

import { setIsBookmarkOpen, setIsChatDrawerOpen, setIsNotesDrawerOpen, setIsParticipantDrawerOpen, setOppoDetails } from "../reducers/common-reducer";
import {
    setDownloadImageFailed,
    setEnableCropButton,
    setExtractTextInprogress,
    setFetchedOCRText,
    setOcrCopyText,
    setOpenCopyTextModal,
    setShowOrientationModal,
    addEditCustomToastInstanceArray,
    removeCustomToastInstanceArray,
} from "../reducers/extractText-reducer";

import { LogFirebase } from "./firestore";
import googleEvent from "./googleEvent";

import { isLocalUserStreaming, isvideoenabled } from "../components/Twilio/Room/roomFunction";
import CustomToast from "../components/UI/customToast";
import { performStartStopVideo } from "../components/Twilio/VideoCall/VideoUtils";

import takePhotoService from "./takePhotoService";
import navigatorService from "./navigatorService";
import watermarkImageService from "./WatermarkImage/watermarkImageService";
import zoomService from "./zoomService";

import { checkPublishVideoOnExit, getParticipantIndex, sendDataTrack, sendMsgForPointer } from "../shared/dataTrackFunction";
import chatService from "./chatService";
import { dualStreamEnabled } from "../shared/utility";
import { setARmarkupLiveStream, setConfirmExitMarkup, setMarkupInprogress } from "../reducers/markup-reducer";
import markupService from "./MarkupService/markupService";
import { setMeasurementView } from "../reducers/measurement-reducer";
import arMarkupService from "./MarkupService/arMarkupService";
import { attachVideoTracksStreamingIdentityVise } from "../components/GalleryView/GalleryViewUtils";

// Use lazy require to avoid circular dependency with livePointerService
const getLivePointerService = () => require("../components/LivePointer/livePointerService").default;

class ExtractTextService {
    extractTextList = [];
    dataTrackStatus = {
        uploadImageStart: "1",
        uploadImageComplete: "2",
        uploadImageFail: "8",
        cancelOCR: "7",
        stopOCR: "3",
    };
    ocrCanvas = null;
    ocrCanvasProperty = {
        height: 0,
        width: 0,
    };
    el = null;
    elb = null;
    croppedimage = false; // Image cropped or not
    cropImgCal = {
        x: 0,
        y: 0,
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        origX: 0,
        origY: 0,
    };
    cropStarted = false;
    origX = 0;
    origY = 0;
    tempentireimagedata = null;
    disabledDrawing = false;
    tempcropimagedata = null;
    ocrImgURL = null;
    markupOCRCancelled = false;
    OCROrientation = 0;
    toastId = 1;
    // save Entire and cropped Image
    uploadImageToastId = 2;
    uploadingCount = 0;
    uploadedCount = 0;
    clearCheckUploadTimeout = null;

    createOCRPhoto = () => {
        this.croppedimage = false;
        const extractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;
        if (extractTextInprogress !== EXTRACT_TEXT_VIEW.PREPARE_VIEW && extractTextInprogress !== EXTRACT_TEXT_VIEW.OCR_VIEW) {
            //// utility.removeSidebarZindex();
            if (isLocalUserStreaming()) {
                // Check if the local user is streaming
                this.startmyscreenocr(); // Start capturing and uploading image if the agent's video is on
            } else {
                this.onStartPrepareView("OCR");
                this.checkUploadTimeout("OCR"); // Check upload timeout for OCR
            }
            googleEvent.logEvent(EVENT_NAME.STARTED_OCR);

            this.closeAllModel();
            LogFirebase("OCR", "extracttext_clicked", "streaming user=" + reduxStore.getState().twilioEvents.streamingPartiIdentity);

            // Set toast message based on screen sharing status
            const agentPausedToast =
                reduxStore.getState().twilioEvents.isLocalUserScreenSharing || reduxStore.getState().twilioEvents.isOpponentUserScreenSharing
                    ? Localize[PublicVariables.currentLanguageObj?.languageCode]["screenshare_paused_by_agent"]
                    : Localize[PublicVariables.currentLanguageObj?.languageCode]["video_paused_by_agent"];

            // Send data track to all users for OCR started by Agent
            let msg = {
                notification_type: NOTIFICATION_TYPES.EXTRACT_TEXT.AGENT_TO_ALL,
                identity: CALL_DATA.localIdentity,
                total_remote_participations: reduxStore.getState().twilioEvents.participantIdentities?.length,
                agent_paused_toast: agentPausedToast,
            };
            sendDataTrack(msg);
            LogFirebase("OCR", "send_msg", "Start Extract Text");
        } else {
            CustomToast.info(Localize[PublicVariables.currentLanguageObj?.languageCode]["ocr_inprogress"]);
        }
    };

    closeAllModel = () => {
        /* Close chat input keyboard when chat drawer getting close*/
        const isChatDrawerOpen = reduxStore.getState().commonReducer.isChatDrawerOpen;
        if (isChatDrawerOpen && navigatorService.isMobileDeviceOrIpadOs()) {
            const chatInputElement = document.querySelector("#chat_input");
            if (chatInputElement) {
                chatInputElement.blur();
            }
        }
        reduxStore.dispatch(setIsParticipantDrawerOpen(false));
        reduxStore.dispatch(setIsBookmarkOpen(false));
        reduxStore.dispatch(setIsChatDrawerOpen(false));
        reduxStore.dispatch(setIsNotesDrawerOpen(false));
        //// if(from != 'fromLivePointer' && from != 'callSetting') {
        ////     let actionMsg = {action:"modelClose"};
        ////     $rootScope.handleNotification(actionMsg);
        ////    $('.customizer').addClass('customizer-active');
        //// }
    };

    onStartPrepareView = (type) => {
        //// $("#zoomContainer").hide();
        //// if(_this.markupLiveStream || _this.arMarkupLiveStream){
        ////     if($("#collapseContainer")){$("#collapseContainer").hide();}
        ////     if($(".livePointerMainContainer")){$(".livePointerMainContainer").hide();}
        //// }
        //// $('.cust-collapse-video').addClass('btn_z_index');
        //// if(flags && flags.showMeDualStream=='1'){
        ////     $('.gallery-pin-view').addClass("gallery-view-with-markup");
        //// }

        const callActionDropdown = document.getElementById("call-action-menu"); //mweb- hide bottom menu bar when more is clicked and markup-ocr is on
        if (callActionDropdown?.classList?.contains("call-action-moremenu-open")) {
            callActionDropdown.classList.remove("call-action-moremenu-open");
        }
        if (type === "Markup") {
            if (
                reduxStore.getState().markup.markupInprogress !== MARKUP_VIEW.PREPARE_VIEW &&
                reduxStore.getState().markup.markupInprogress !== MARKUP_VIEW.START_MARKUP_VIEW
            ) {
                reduxStore.dispatch(setMarkupInprogress(MARKUP_VIEW.PREPARE_VIEW));
            }
            const timeOutScreen_Markup = document.getElementById("timeOutScreen_Markup");
            if (timeOutScreen_Markup) {
                timeOutScreen_Markup.style.display = "none";
            }
        }
        if (type === "ARMarkup") {
            if (
                reduxStore.getState().markup.arMarkupLiveStream !== AR_MARKUP_VIEW.PREPARE_VIEW &&
                reduxStore.getState().markup.arMarkupLiveStream !== AR_MARKUP_VIEW.START_MARKUP_VIEW
            ) {
                reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.PREPARE_VIEW));
                const videoCallView = document.getElementById("video-call");
                videoCallView.style.display = "none";
            }
            const timeOutScreen_Markup = document.getElementById("timeOutScreen_Markup");
            if (timeOutScreen_Markup) {
                timeOutScreen_Markup.style.display = "none";
            }
        }
        if (type === "OCR") {
            this.handleOCRPrepareView();
        }
        if (type === "Measurement") {
            this.handleMeasurementPrepareView();
        }
    };

    handleOCRPrepareView = () => {
        if (reduxStore.getState().extractText.extractTextInprogress !== EXTRACT_TEXT_VIEW.PREPARE_VIEW) {
            reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.PREPARE_VIEW));
        }
        const timeOutScreen_OCR = document.getElementById("timeOutScreen_OCR");
        if (timeOutScreen_OCR) {
            timeOutScreen_OCR.style.display = "none";
        }
    };

    handleMeasurementPrepareView = () => {
        if (
            reduxStore.getState().measurement.measurementView !== MEASUREMENT_VIEW.PREPARE_VIEW &&
            reduxStore.getState().measurement.measurementView !== MEASUREMENT_VIEW.START_MEASUREMENT_VIEW
        ) {
            reduxStore.dispatch(setMeasurementView(MEASUREMENT_VIEW.PREPARE_VIEW));
            const videoCallView = document.getElementById("video-call");
            videoCallView.style.display = "none";
        }
        const timeOutScreen_Measurement = document.getElementById("timeOutScreen_Measurement");
        if (timeOutScreen_Measurement) {
            timeOutScreen_Measurement.style.display = "none";
        }
    };
    // start OCR take Photo function
    startmyscreenocr = () => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;
        //// utility.removeSidebarZindex();
        this.closeAllModel();
        // send message for uploading image
        let msg = {
            notification_type: NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT,
            identity: CALL_DATA.localIdentity,
            status: this.dataTrackStatus.uploadImageStart,
            device_type: GLOBAL_MEETING_DATA.device_type,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
        };
        sendDataTrack(msg);
        this.OCROrientation = navigatorService.getOrientation();
        LogFirebase("OCR", "send_msg_image_uploading_status", "UPLOADING");
        CALL_DATA.myscreenShareON = Boolean(reduxStore.getState().twilioEvents.isLocalUserScreenSharing);
        CALL_DATA.myVideoON = Boolean(startLocalVideo);
        let width;
        let height;
        let video;
        video = document.querySelector("#expandedVideo video");
        if (video != undefined && video != null && video != "" && video.videoWidth != 0 && video.videoHeight != 0) {
            width = video.videoWidth;
            height = video.videoHeight;
            this.onStartPrepareView("OCR");
            if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                LogFirebase("OCR", "videoConstraints", { height: height, width: width });
            }
        } else {
            LogFirebase("OCR", "video_element_not_found", "");
        }
        takePhotoService.imageCaptureForTakePhotoMarkupOCRCanvas("OCR", video, width, height);
    };

    sendSuccessfullImageUploadMsg = (fromWhere, fileUrl) => {
        const deviceOrientation = navigatorService.getOrientation();
        if (fromWhere == "OCR") {
            this.ocrImgURL = fileUrl;
        } else {
            markupService.annImgURL = fileUrl;
        }
        const msg = {
            identity: CALL_DATA.localIdentity,
            status: this.dataTrackStatus.uploadImageComplete,
            device_type: GLOBAL_MEETING_DATA.device_type,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
            orientation: deviceOrientation, // unknown orientation
        };
        if (fromWhere === "OCR") {
            msg.notification_type = NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT;
            msg.image_url = this.ocrImgURL;
        } else {
            msg.notification_type = NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT;
            msg.image_url = markupService.annImgURL;
        }
        sendDataTrack(msg);
        LogFirebase(fromWhere, "send_msg_image_uploading_status", "UPLOADED");
    };

    downloadImageToRenderInCanvas = (fromWhere, width, height) => {
        const xhr = new XMLHttpRequest();
        if (fromWhere == "OCR") {
            xhr.open("GET", this.ocrImgURL, true);
        } else {
            xhr.open("GET", markupService.annImgURL, true);
        }
        xhr.send();
        xhr.responseType = "blob";

        xhr.onload = (_event) => {
            if (xhr.status === 200) {
                LogFirebase(fromWhere, "image_downloading_status", "DOWNLOADED");
                // blob format file in response
                const blobfile1 = xhr.response;
                const canfile1 = new File([blobfile1], "callimage.jpeg", { type: "image/jpeg" });
                if (fromWhere === "OCR") {
                    const canvas = document.getElementById("outocrcanvas");
                    canvas.width = width;
                    canvas.height = height;
                    canvas.style.display = "block";
                    this.ocrCanvas = new fabric.Canvas("outocrcanvas");
                    this.renderImageForOCR(canfile1);
                } else {
                    const canvas = document.getElementById("markup-outer-canvas");
                    canvas.width = width;
                    canvas.height = height;
                    canvas.style.display = "block";
                    markupService.renderImageForMarkup(canfile1, false);
                }
            }
        };
        // event triggered if download fails
        xhr.onerror = (e) => {
            LogFirebase(fromWhere, "image_downloading_status", "FAILED");
            if (fromWhere == "OCR") {
                let msg =
                    Localize[PublicVariables.currentLanguageObj?.languageCode]["download_failed"] +
                    " " +
                    Localize[PublicVariables.currentLanguageObj?.languageCode]["please_try_again"];
                CustomToast.error(msg);
                this.exitocrcanvas();
            } else {
                reduxStore.dispatch(setDownloadImageFailed(true));
            }
        };
    };

    sendFailedImageUploadMsg = (fromWhere, result) => {
        //do not show any error if markup cancelled manually
        if (this.markupOCRCancelled) {
            this.markupOCRCancelled = false;
            return;
        }
        //send remote user upload failed
        let errText = Localize[PublicVariables.currentLanguageObj?.languageCode]["upload_failed"];
        let errStrKey = "upload_failed";
        if (result.errorcode == "-111") {
            errText = result.error;
            errStrKey = "error_occured_in_processing_the_request";
        }
        const msg = {
            identity: CALL_DATA.localIdentity,
            status: this.dataTrackStatus.uploadImageFail,
            device_type: GLOBAL_MEETING_DATA.device_type,
            body: errStrKey,
        };
        //send remote user upload failed
        if (fromWhere == "OCR") {
            msg.notification_type = NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT;
            reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OFF_VIEW));
        } else {
            msg.notification_type = NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT;
            reduxStore.dispatch(setMarkupInprogress(MARKUP_VIEW.OFF_VIEW));
            reduxStore.dispatch(setConfirmExitMarkup(false));
        }
        sendDataTrack(msg);
        this.onExitPrepareView(true);
        // if upload failed from ocr/markup then my video start then again start it
        setTimeout(() => {
            attachVideoTracksStreamingIdentityVise();
        }, 1000);
        CustomToast.error(errText);
        LogFirebase(fromWhere, "image_uploading_status", "FAILED");

        if (isvideoenabled()) {
            sendMsgForPointer(STATUS.ENABLED);
        }
    };

    handleUploadImageCanvasSetup = (video, width, height, imageBitmap, fromWhere) => {
        //// if (fromWhere == "Markup") {
        //// $scope.markupinprogress = true;
        ////}
        // this canvas is just for uploading image for OCR
        const canvas = document.getElementById("screenshotcanvas");
        const context = canvas?.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        if (imageBitmap) {
            LogFirebase(fromWhere, "imageCapture_grabFrame_imageBitmap", {
                imageBitmapWidth: imageBitmap.width,
                imageBitmapHeight: imageBitmap.height,
            });
            context.drawImage(imageBitmap, 0, 0, imageBitmap.width, imageBitmap.height);
        } else {
            context.drawImage(video, 0, 0, width, height);
        }
        this.tempentireimagedata = canvas.toDataURL("image/jpeg");
        const imageData = this.tempentireimagedata;
        console.log(imageData);
        if (fromWhere == "OCR") {
            this.checkUploadTimeout("OCR");
        } else {
            this.checkUploadTimeout("Markup");
        }
        return imageData;
    };

    uploadImageForMarkupOCR = (video, width, height, imageBitmap, fromWhere) => {
        if (width && height) {
            const imageData = this.handleUploadImageCanvasSetup(video, width, height, imageBitmap, fromWhere);

            // convert base64/URLEncoded data component to raw binary data held in a string
            const blob = watermarkImageService.__base64ToBlobImage.convertData(imageData);

            //send request to backend with form data
            takePhotoService.uploadImage("tempAnnotation", blob, null, (response) => {
                // bookmark = null
                const result = response.data;
                if (
                    response.success > 0 &&
                    (reduxStore.getState().extractText?.extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW ||
                        reduxStore.getState().markup.markupInprogress === MARKUP_VIEW.PREPARE_VIEW)
                ) {
                    //send data track for Image uploaded and ready to download.
                    this.sendSuccessfullImageUploadMsg(fromWhere, result.fileUrl);
                    // download Image to Render In the Canvas for OCR
                    this.downloadImageToRenderInCanvas(fromWhere, width, height);
                } else {
                    this.sendFailedImageUploadMsg(fromWhere, result);
                }
            });
        } else {
            console.log("video not found");
            reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OFF_VIEW));
            LogFirebase("OCR", "width_or_height_unavailable", "");
        }
    };

    createFabricRectangle = (strokeColour) => {
        return new fabric.Rect({
            fill: "transparent",
            originX: "left",
            originY: "top",
            stroke: strokeColour,
            strokeWidth: 1,
            opacity: 1,
            width: 1,
            height: 1,
            highlight: true,
            selectable: false,
        });
    };

    mouseDownEvent = (event, pixelratio) => {
        this.el.set({ height: 0, width: 0, visible: true });
        this.elb.set({ height: 0, width: 0, visible: true });
        this.cropImgCal = {
            x: 0,
            y: 0,
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            origX: 0,
            origY: 0,
        };
        let pointer = this.ocrCanvas.getPointer(event.e);
        this.origX = pointer.x;
        this.origY = pointer.y;
        this.cropImgCal.origX = pointer.x * pixelratio;
        this.cropImgCal.origY = pointer.y * pixelratio;
        this.cropImgCal.left = this.cropImgCal.origX;
        this.cropImgCal.top = this.cropImgCal.origY;
        if (this.disabledDrawing) return;

        this.el.set({
            left: Math.abs(pointer.x),
            top: Math.abs(pointer.y),
            width: Math.abs(this.origX - pointer.x),
            height: Math.abs(this.origY - pointer.y),
        });
        this.elb.set({ left: Math.abs(pointer.x), top: Math.abs(pointer.y) });
        this.cropStarted = true; // crop old var
        this.el.setCoords();
        this.elb.setCoords();
        this.ocrCanvas.bringToFront(this.el);
        this.ocrCanvas.bringToFront(this.elb);
        this.ocrCanvas.add(this.el);
        this.ocrCanvas.add(this.elb);
        this.ocrCanvas.renderAll();
    };

    mouseMoveEvent = (event, pixelratio) => {
        // for drawing rectangle on image
        let pointer = this.ocrCanvas.getPointer(event.e);
        this.cropImgCal.x = pointer.x * pixelratio;
        this.cropImgCal.y = pointer.y * pixelratio;

        this.cropImgCal.width = Math.abs(this.cropImgCal.origX - this.cropImgCal.x);
        this.cropImgCal.height = Math.abs(this.cropImgCal.origY - this.cropImgCal.y);

        this.el.set({ width: Math.abs(this.origX - pointer.x), height: Math.abs(this.origY - pointer.y) });
        this.elb.set({ width: Math.abs(this.origX - pointer.x), height: Math.abs(this.origY - pointer.y) });

        if (this.origX > pointer.x) {
            this.el.set({ left: Math.abs(pointer.x) });
            this.elb.set({ left: Math.abs(pointer.x) });
        }
        if (this.origY > pointer.y) {
            this.el.set({ top: Math.abs(pointer.y) });
            this.elb.set({ top: Math.abs(pointer.y) });
        }
        if (this.cropImgCal.origX > this.cropImgCal.x) {
            this.cropImgCal.left = Math.abs(this.cropImgCal.x);
        }
        if (this.cropImgCal.origY > this.cropImgCal.y) {
            this.cropImgCal.top = Math.abs(this.cropImgCal.y);
        }
        this.el.setCoords();
        this.elb.setCoords();
        this.ocrCanvas.renderAll();
    };

    mouseUpEvent = () => {
        googleEvent.logEvent(EVENT_NAME.IMAGE_CROPPED_FOR_OCR);
        LogFirebase("OCR", "image_cropped", "height=" + this.el.height + "::width=" + this.el.width);
        if (this.el.height >= 10 && this.el.width >= 10) {
            this.ocrCanvas.renderAll();
            this.croppedimage = true;
            const firstUpperCanvas = document.querySelector(".upper-canvas");
            if (firstUpperCanvas) {
                firstUpperCanvas.classList.remove("crosshair-cursor");
                firstUpperCanvas.classList.add("no-drop-cursor");
            }
            this.cropAndScan();
        } else {
            reduxStore.dispatch(setEnableCropButton(false));
            reduxStore.dispatch(setOpenCopyTextModal(false));
            this.showToastMessage(
                Localize[PublicVariables.currentLanguageObj?.languageCode]["selected_area_is_small"] +
                    Localize[PublicVariables.currentLanguageObj?.languageCode]["please_select_large_area"],
                false,
                this.toastId
            );
        }
    };

    setupCanvasEvents = () => {
        this.disabledDrawing = false;
        this.el = this.createFabricRectangle("white");
        this.el.set({ lineWidth: 5, visible: true });
        this.elb = this.createFabricRectangle("black");
        this.elb.set({ strokeDashArray: [5, 5], visible: true }); // the pattern of dashes and gaps that is used to outline shapes.
        let pixelratio = window.devicePixelRatio;
        if (pixelratio == null || pixelratio == undefined || pixelratio == 0) {
            pixelratio = 1;
        }
        this.ocrCanvas.on("mouse:down", (event) => {
            if (!this.croppedimage) {
                this.mouseDownEvent(event, pixelratio);
            }
        });

        this.ocrCanvas.on("mouse:move", (event) => {
            if (!this.croppedimage && this.cropStarted && !this.disabledDrawing) {
                this.mouseMoveEvent(event, pixelratio);
            }
        });

        this.ocrCanvas.on("mouse:up", () => {
            this.cropStarted = false;
            if (!this.croppedimage) {
                this.mouseUpEvent();
            }
        });
    };

    fetchEntireImageData = () => {
        if (GLOBAL_MEETING_DATA.isAgent && !this.tempentireimagedata) {
            // fetch image data of entire image
            let canvas = document.getElementById("outocrcanvas");
            let context = canvas.getContext("2d");
            console.log(context);
            this.tempentireimagedata = canvas.toDataURL("image/jpeg");
            console.log(this.tempentireimagedata);
        }
    };

    addClassInCanvasForDrawing = () => {
        const canvasContainer = document.querySelector(".canvas-container");
        if (canvasContainer) {
            canvasContainer.classList.add("custom-canvas-container");
            canvasContainer.style.width = this.ocrCanvas.width + "px";
        }
        const firstLowerCanvas = document.querySelector(".lower-canvas");
        if (firstLowerCanvas) firstLowerCanvas.classList.add("custom-lower-canvas");
        const firstUpperCanvas = document.querySelector(".upper-canvas");
        if (firstUpperCanvas) firstUpperCanvas.classList.add("custom-upper-canvas");

        //// const deviceOrientation = navigatorService.getOrientation();
        //// if((deviceOrientation == '3' || deviceOrientation == '4') && PublicVariables.isMobile){
        ////     $(".canvas-container").addClass("landscape_markup_canvas");
        ////     if($scope.mobile_iPad) {
        ////         $(".canvas-container").addClass("landscape_markup_canvas_iPad");
        ////     }
        ////     $scope.canvasCreatedLandscape=true;
        //// }else{
        ////     $(".canvas-container").removeClass("landscape_markup_canvas");
        ////     $(".canvas-container").removeClass("landscape_markup_canvas_iPad");
        ////     $scope.canvasCreatedLandscape=false;
        //// }
    };

    showStartOCRToastMsg = () => {
        if (GLOBAL_MEETING_DATA.isAgent) {
            // if agent
            LogFirebase("OCR", "message_shown", "Select are to extract text");
            this.showToastMessage(Localize[PublicVariables.currentLanguageObj?.languageCode]["select_area_extract_text"], false, this.toastId);
        } else {
            // if guest user
            LogFirebase("OCR", "message_shown", "video paused by agent");
            this.showToastMessage(Localize[PublicVariables.currentLanguageObj?.languageCode]["video_paused_by_agent"], false, this.toastId);
        }
    };

    handleImageFromFabric = (img) => {
        this.ocrCanvasProperty.width = img.width;
        this.ocrCanvasProperty.height = img.height;
        let oImg = null;
        if (img.width < 950) {
            // we don't touch  this as it is for video resolution
            this.ocrCanvas.setWidth(img.width);
            this.ocrCanvas.setHeight(img.height < 600 ? img.height : "600");
            oImg = img.set({
                width: img.width,
                centeredRotation: true,
                centeredScaling: true,
                selectable: false,
            });
        } else {
            oImg = img.set({
                centeredRotation: true,
                centeredScaling: true,
                backgroundImageStretch: false,
                selectable: false,
            });
            oImg.scaleToWidth(img.width); // for the fix of screenshare resolution is low we removed 950 width scale
        }
        oImg.hasRotatingPoint = true;
        this.ocrCanvas.setWidth(img.width * oImg.scaleX);
        console.log(this.ocrCanvas);

        this.addClassInCanvasForDrawing();

        this.ocrCanvas.setHeight(img.height * oImg.scaleY);
        console.log("going to set call ocr view");
        this.ocrCanvas.setBackgroundImage(oImg).renderAll();
        this.ocrCanvas.selection = false;
    };

    // render image on canvas function
    renderImageForOCR = (canfile1) => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;

        this.showStartOCRToastMsg();

        console.log("in render image function!");
        const reader = new FileReader();
        reader.onload = (f) => {
            const data = f.target.result;
            fabric.Image.fromURL(data, (img) => {
                console.log(img);

                this.handleImageFromFabric(img);

                this.onExitPrepareView(false);

                reduxStore.dispatch(setOpenCopyTextModal(false));
                if (reduxStore.getState().extractText.extractTextInprogress !== EXTRACT_TEXT_VIEW.OCR_VIEW) {
                    reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OCR_VIEW));
                }

                if (!dualStreamEnabled() && startLocalVideo) {
                    // to unpublish video before starting OCR to save bandwidth
                    performStartStopVideo();
                }

                this.fetchEntireImageData();

                //below action is only for agent. only agent can perform extract text.
                if (GLOBAL_MEETING_DATA.isAgent) {
                    const firstUpperCanvas = document.querySelector(".upper-canvas");
                    if (firstUpperCanvas) firstUpperCanvas.classList.add("crosshair-cursor");
                    this.setupCanvasEvents();
                }
            });
        };
        reader.readAsDataURL(canfile1);
    };

    convertOCRDataToBlob = () => {
        let ocrData = "";
        this.extractTextList.forEach(function (val) {
            ocrData = ocrData + val.ocrTime + ": " + val.text + "\n";
        });
        console.log(ocrData);
        let textToBLOB = new Blob([ocrData], { type: "text/plain;charset=utf-8" }); // Convert the text to BLOB.
        return textToBLOB;
    };

    // save entire / cropped image in OCR Pop up
    saveOCRimage = (key) => {
        LogFirebase("OCR", "saved_clicked", "Agent uploading extracted image");
        this.uploadingCount = this.uploadingCount + 1;
        this.showToastMessage(
            Localize[PublicVariables.currentLanguageObj?.languageCode]["uploading_image"] +
                " " +
                "(" +
                (this.uploadedCount + 1) +
                "/" +
                this.uploadingCount +
                ")",
            true,
            this.uploadImageToastId
        );
        // convert canvas to image
        let mainImage = new Image();
        let imageWidth,
            imageHeight = null;
        let canvas = document.getElementById("screenshotcanvas");
        let context = canvas.getContext("2d");
        if (key == "entire") {
            // entire image data
            mainImage.src = this.tempentireimagedata; // entire image data
            imageWidth = this.ocrCanvasProperty.width;
            imageHeight = this.ocrCanvasProperty.height;
            mainImage.onload = () => {
                let svgImg = new Image();
                const deviceOrientation = navigatorService.getOrientation();
                let objVal = watermarkImageService.__watermarkImage.fetchImageWaterMark({
                    screenType: "ocr",
                    width: imageWidth,
                    height: imageHeight,
                    localOrientation: deviceOrientation,
                    bookmark: false,
                    liveLat: false,
                    liveLong: false,
                    localSS: CALL_DATA.myscreenShareON,
                    localVideo: CALL_DATA.myVideoON,
                });
                const { imageSrc, canvasHeight } = objVal;
                svgImg.src = imageSrc;
                console.log(svgImg.src);
                if (imageWidth && imageHeight) {
                    canvas.width = imageWidth;
                    canvas.height = canvasHeight;
                    context.drawImage(mainImage, 0, 0, imageWidth, imageHeight);
                    svgImg.onload = () => {
                        context.drawImage(svgImg, 0, 0);
                        let imageData = canvas.toDataURL("image/jpeg");
                        console.log(imageData);
                        this.uploadOCRImage(imageData);
                    };
                }
            };
        } else if (key == "cropped") {
            //cropped image data
            mainImage.src = this.tempcropimagedata;
            imageWidth = this.cropImgCal.width;
            imageHeight = this.cropImgCal.height;
            mainImage.onload = () => {
                if (imageWidth && imageHeight) {
                    canvas.width = imageWidth;
                    canvas.height = imageHeight;
                    context.drawImage(mainImage, 0, 0, imageWidth, imageHeight);
                    let imageData = canvas.toDataURL("image/jpeg");
                    console.log(imageData);
                    this.uploadOCRImage(imageData);
                }
            };
        }
    };

    // in ocr, upload entire or cropped image
    uploadOCRImage = (imageData) => {
        console.log("upload image function");
        let blob = watermarkImageService.__base64ToBlobImage.convertData(imageData);
        //send request to backend with form data
        takePhotoService.uploadImage("ocr", blob, null, (response) => {
            let result = response.data;
            if (response.success > 0) {
                console.log("ocr final upload success");
                if (PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
                    LogFirebase("OCR", "saved_by_agent", " OCR uploaded::" + result.fileUrl);
                } else {
                    LogFirebase("OCR", "saved_by_agent", " OCR uploaded");
                }
                this.uploadedCount = parseInt(this.uploadedCount) + 1;
                takePhotoService.addThumbInList(result.thumbUrl, result.fileUrl, result.fileName);
                this.showToastMessage(
                    Localize[PublicVariables.currentLanguageObj?.languageCode]["uploading_image"] +
                        " " +
                        "(" +
                        (this.uploadedCount + 1) +
                        "/" +
                        this.uploadingCount +
                        ")",
                    true,
                    this.uploadImageToastId
                );
                if (this.uploadedCount == this.uploadingCount) {
                    this.uploadingCount = 0;
                    this.uploadedCount = 0;
                    this.showToastMessage(
                        Localize[PublicVariables.currentLanguageObj?.languageCode]["successfully_uploaded"],
                        false,
                        this.uploadImageToastId
                    );
                    setTimeout(() => {
                        this.dismissAgentToast(this.uploadImageToastId);
                    }, 2000);
                }
            } else {
                this.dismissAgentToast(this.uploadImageToastId);
                this.uploadingCount = this.uploadingCount - 1;
                CustomToast.error(Localize[PublicVariables.currentLanguageObj?.languageCode]["upload_failed"]);
                LogFirebase("OCR", "saved_by_agent", "UPLOAD FAILED");
            }
        });
    };

    dismissAgentToast = (toastToRemoveId) => {
        reduxStore.dispatch(removeCustomToastInstanceArray(toastToRemoveId));
    };

    showToastMessage = (message, isLoading, id) => {
        reduxStore.dispatch(addEditCustomToastInstanceArray({ id, message: message, isLoading: isLoading, showCloseIcon: false }));
    };

    // crop the image and call fetch text detection api
    cropAndScan = () => {
        if (!reduxStore.getState().extractText.openCopyTextModal) {
            this.showToastMessage(Localize[PublicVariables.currentLanguageObj?.languageCode]["extract_text_from_image"], false, this.toastId);
        }

        const canvas = document.getElementById("outocrcanvas"); // Original canvas
        const context = canvas.getContext("2d");
        //get cropped image data
        const removedash = 2; // removed rectangle dash line from crop image
        const tempimagedata = context.getImageData(
            this.cropImgCal.left + removedash,
            this.cropImgCal.top + removedash,
            this.cropImgCal.width - removedash,
            this.cropImgCal.height - removedash
        );
        const tempcropcanvas = document.createElement("canvas"); // create temporary canvas
        tempcropcanvas.width = this.cropImgCal.width;
        tempcropcanvas.height = this.cropImgCal.height;
        let tempctx = tempcropcanvas.getContext("2d");
        tempctx.putImageData(tempimagedata, 0, 0); // put cropped image data on temporary canvas for getting cropped image source
        console.log(tempimagedata);
        this.disabledDrawing = true;
        this.tempcropimagedata = tempcropcanvas.toDataURL("image/png"); // cropped image source
        //base64/URLEncoded data of vision API for geeting OCR text
        let byteString1;
        byteString1 = this.tempcropimagedata.split(",")[1];
        axios
            .post(
                OCR_API_URL,
                {
                    requests: [
                        {
                            image: {
                                content: byteString1,
                            },
                            features: [
                                {
                                    type: "TEXT_DETECTION",
                                    maxResults: 50,
                                },
                            ],
                        },
                    ],
                },
                {
                    headers: { "Content-Type": "application/json" },
                }
            )
            .then((response) => {
                console.log("in success");
                console.log(response);
                const fullTextAnnotation = response.data?.responses[0]?.fullTextAnnotation;
                if (fullTextAnnotation) {
                    reduxStore.dispatch(setFetchedOCRText(true));
                    reduxStore.dispatch(setOcrCopyText(fullTextAnnotation.text));
                    const temptext = fullTextAnnotation.text?.replace(/\n/g, " ");
                    this.extractTextList.push({ ocrTime: moment().format("hh:mm A"), text: temptext });
                } else {
                    reduxStore.dispatch(setFetchedOCRText(false));
                    reduxStore.dispatch(
                        setOcrCopyText(
                            Localize[PublicVariables.currentLanguageObj?.languageCode]["not_extract_text_from_image"] +
                                Localize[PublicVariables.currentLanguageObj?.languageCode]["try_again_clear_image_or_reselect_region"]
                        )
                    );
                }
                this.dismissAgentToast(this.toastId);
                const firstUpperCanvas = document.querySelector(".upper-canvas");
                if (firstUpperCanvas) {
                    firstUpperCanvas.classList.add("crosshair-cursor");
                    firstUpperCanvas.classList.remove("no-drop-cursor");
                }
                this.croppedimage = false;
                reduxStore.dispatch(setEnableCropButton(true));
                if (reduxStore.getState().extractText.extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW) {
                    reduxStore.dispatch(setOpenCopyTextModal(true));
                }
                this.disabledDrawing = false;
            })
            .catch((error) => {
                // Handle error
                console.log("Error:", error);
            });
    };

    removeCopyModel = () => {
        this.el.set({ height: 0 });
        this.el.set({ width: 0 });
        this.elb.set({ height: 0 });
        this.elb.set({ width: 0 });
        this.el.set({ visible: false });
        this.elb.set({ visible: false });
        this.cropImgCal = {
            x: 0,
            y: 0,
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            origX: 0,
            origY: 0,
        };
        this.ocrCanvas.renderAll();
        reduxStore.dispatch(setEnableCropButton(false));
        reduxStore.dispatch(setOpenCopyTextModal(false));
        this.dismissAgentToast(this.toastId);
    };

    //checks if 10 seconds passed and markup/ocr image has not been uploaded. then show button to cancel the view.
    checkUploadTimeout = () => {
        this.clearCheckUploadTimeout = setTimeout(() => {
            //after 10 sec if prepare view is not set to false then show cancel markup/ocr
            if (reduxStore.getState().extractText?.extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW) {
                const timeOutScreen_OCR = document.getElementById("timeOutScreen_OCR");
                if (timeOutScreen_OCR) {
                    timeOutScreen_OCR.style.display = "block";
                }
            }

            if (
                reduxStore.getState().markup.markupInprogress === MARKUP_VIEW.PREPARE_VIEW ||
                reduxStore.getState().markup.arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW
            ) {
                const timeOutScreen_Markup = document.getElementById("timeOutScreen_Markup");
                if (timeOutScreen_Markup) {
                    timeOutScreen_Markup.style.display = "block";
                }
            }

            if (reduxStore.getState().measurement.measurementView === MEASUREMENT_VIEW.PREPARE_VIEW) {
                const timeOutScreen_Measurement = document.getElementById("timeOutScreen_Measurement");
                if (timeOutScreen_Measurement) {
                    timeOutScreen_Measurement.style.display = "block";
                }
            }
        }, 10000);
    };

    sendCancelMarkupOCRPrepareView = (type) => {
        //when user who is uploading, cancels the markup/ocr
        if (CALL_DATA.localIdentity == reduxStore.getState().twilioEvents.streamingPartiIdentity) {
            let abortImageRequestButton = document.getElementById("abortImageRequest");
            if (abortImageRequestButton) {
                this.markupOCRCancelled = true;
                abortImageRequestButton.click();
            }
        }

        let notificationType = NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT; //markup
        if (type == "OCR") {
            notificationType = NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT; //OCR
        } else if (type == "ARMarkup") {
            notificationType = NOTIFICATION_TYPES.AR_MARKUP.GUEST_TO_AGENT; //ARmarkup
        }
        const msg = {
            notification_type: notificationType,
            identity: CALL_DATA.localIdentity,
            status: this.dataTrackStatus.cancelOCR,
            device_type: GLOBAL_MEETING_DATA.device_type,
        };
        sendDataTrack(msg);
        this.hideMarkupOCRAndShowMsg(type, type.toLowerCase() + "_cancelled");
        LogFirebase(type, "prepareView_cancelled_by", CALL_DATA.localIdentity);
    };

    /**when preparing markup/OCR upload fails on streaming user and he sends upload failed*/
    hideMarkupOCRAndShowMsg = (type, msg) => {
        if (type == "Markup") {
            reduxStore.dispatch(setConfirmExitMarkup(false));
            reduxStore.dispatch(setMarkupInprogress(MARKUP_VIEW.OFF_VIEW));
        } else if (type == "OCR") {
            reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OFF_VIEW));
        } else if (type == "ARMarkup") {
            arMarkupService.ARMarkupStopVariable("hideMarkupOCRAndShowMsg");
        }
        this.onExitPrepareView(true);
        if (msg.indexOf("cancelled") > -1) {
            CustomToast.info(Localize[PublicVariables.currentLanguageObj?.languageCode][msg]);
        } else {
            CustomToast.error(Localize[PublicVariables.currentLanguageObj?.languageCode][msg]);
        }

        if (msg.indexOf("upload_failed") > -1) {
            // if upload failed from ocr then my video start then again start it
            if (CALL_DATA.myVideoON && !dualStreamEnabled()) {
                checkPublishVideoOnExit();
            } else {
                setTimeout(() => {
                    attachVideoTracksStreamingIdentityVise();
                }, 1000);
            }
        }
    };

    onExitPrepareView = (showContainer) => {
        //// if (showContainer) {
        //// const videoCallElement = document.getElementById("video-call");
        //// if (videoCallElement) videoCallElement.style.display = "block";

        //// $("#zoomContainer").show();
        //// if(flags && flags.showMeDualStream=='1'){
        ////     $('.gallery-pin-view').removeClass("gallery-view-with-markup");
        //// }
        //// }
        //// if(_this.markupLiveStream || _this.arMarkupLiveStream){
        ////     if($("#collapseContainer")){$("#collapseContainer").show();}
        ////     if($(".livePointerMainContainer")){$(".livePointerMainContainer").show();}
        //// }
        //// $("#cancelPrepareViewConatiner_Markup").css("display","none");
        const timeOutScreen_OCR = document.getElementById("timeOutScreen_OCR");
        if (timeOutScreen_OCR) {
            timeOutScreen_OCR.style.display = "none";
        }

        const timeOutScreen_Markup = document.getElementById("timeOutScreen_Markup");
        if (timeOutScreen_Markup) {
            timeOutScreen_Markup.style.display = "none";
        }

        const timeOutScreen_Measurement = document.getElementById("timeOutScreen_Measurement");
        if (timeOutScreen_Measurement) {
            timeOutScreen_Measurement.style.display = "none";
        }
        //// $("#cancelPrepareViewConatiner_measurement").css("display","none");
        //// $("#cancelPrepareViewConatiner_ARMarkup").css("display","none");
        //// $('.cust-collapse-video').removeClass('btn_z_index');
        if (showContainer) {
            reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OFF_VIEW)); // flag to hide the view of prepering image on markup/OCR
        }
    };

    removeCanvasElements = () => {
        setTimeout(() => {
            const canvasContainer = document.querySelector(".canvas-container");
            if (canvasContainer) {
                canvasContainer.classList.remove("custom-canvas-container");
            }
            //// $('.customizer').removeClass('customizer-active');
            const firstLowerCanvas = document.querySelector(".lower-canvas");
            if (firstLowerCanvas) firstLowerCanvas.classList.remove("custom-lower-canvas");
            const firstUpperCanvas = document.querySelector(".upper-canvas");
            if (firstUpperCanvas) firstUpperCanvas.classList.remove("custom-upper-canvas");
            if (this.ocrCanvas) {
                this.ocrCanvas.dispose();
                LogFirebase("OCR", "canvas_removed", "OCR canvas Removed");
            }
            let ocrCanvasEle = document.getElementById("outocrcanvas");
            if (ocrCanvasEle) ocrCanvasEle.style.display = "none";
            // Find its sibling with the class 'upper-canvas' and remove it
            let upperCanvasSibling = ocrCanvasEle?.nextElementSibling;
            if (upperCanvasSibling?.classList.contains("upper-canvas")) {
                upperCanvasSibling.remove();
            }
            //// $("#mySidenav, #chatList, #notesList , #languageContainer, #meetingInfoIcon").addClass('sidebar_zindex');
            //// if($scope.flags && $scope.flags.showMeDualStream=='1'){
            ////     $('.gallery-pin-view').removeClass("gallery-view-with-markup");
            //// }
            reduxStore.dispatch(setOcrCopyText(false)); // remove value
            reduxStore.dispatch(setOpenCopyTextModal(false)); // dismiss modal of copy ocr text
        });
    };

    resetOCRState = () => {
        this.tempentireimagedata = null;
        this.tempcropimagedata = null;
        reduxStore.dispatch(setEnableCropButton(false));
        reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OFF_VIEW)); // ocr is not in progress
        reduxStore.dispatch(setShowOrientationModal(false)); //  dismiss change orientation model of OCR
        this.croppedimage = false;
        reduxStore.dispatch(setFetchedOCRText(false));
    };

    sendMessageToStopOCR = () => {
        // stop ocr data track
        let msg = {
            notification_type: NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT,
            status: this.dataTrackStatus.stopOCR,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            lat: CALL_DATA.Latitude,
            long: CALL_DATA.Longitude,
        };
        sendDataTrack(msg);
        LogFirebase("OCR", "send_msg", "Exit OCR");
    };

    handlePinchZoom = () => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;
        if (PublicVariables.isMobile) {
            zoomService.disablePinchZoom();
            if (startLocalVideo) {
                console.log("do nothing");
            } else {
                setTimeout(() => {
                    zoomService.resetPinchZoom();
                }, 1000);
            }
        }
    };

    resetDrawingState = () => {
        this.ocrCanvasProperty = { height: 0, width: 0 };
        this.el = null;
        this.elb = null;
        this.cropImgCal = {
            x: 0,
            y: 0,
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            origX: 0,
            origY: 0,
        };
        if (GLOBAL_MEETING_DATA.isGuest) this.dismissAgentToast(this.toastId);
        this.disabledDrawing = false;
        this.ocrImgURL = null;
        this.markupOCRCancelled = false;
    };

    // exit from the OCR functionality
    exitocrcanvas = (fromNoti, fromCancel, fromEndCall) => {
        this.onExitPrepareView(true);
        // Remove canvas-related elements and classes
        this.removeCanvasElements();
        // Reset OCR-related state and dispatch actions
        this.resetOCRState();
        // Dismiss any agent toast if present
        this.dismissAgentToast(this.toastId);
        // Send message to stop OCR if not from notification or cancellation
        if (!fromNoti && !fromCancel) {
            this.sendMessageToStopOCR();
        }
        // to publish again the unpublished when OCR started
        if (!fromEndCall) {
            if (CALL_DATA.myVideoON && !dualStreamEnabled()) {
                checkPublishVideoOnExit();
            } else {
                setTimeout(() => {
                    attachVideoTracksStreamingIdentityVise();
                }, 1000);
            }
        }
        // Disable pinch zoom and reset if mobile
        this.handlePinchZoom();
        //this should be run after ocr turned off - wait for video to be ready instead of fixed timeout
        const livePointerService = getLivePointerService();
        LogFirebase("AutoLivePointer", "ocr_exit_triggered", true);

        livePointerService.waitForVideoReadyThenExecute(() => {
            // Check for local OR remote video/screenshare availability
            const { screenSharingUsers, videoStreamingUsers, isLocalUserScreenSharing, isOpponentUserScreenSharing } =
                reduxStore.getState().twilioEvents;
            const isAnyVideoAvailable = !isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers);
            const hasLocalOrRemoteVideo = CALL_DATA.myVideoON || CALL_DATA.myscreenShareON || isAnyVideoAvailable;

            if (hasLocalOrRemoteVideo) {
                //send msg for mobile apps for pointer status
                sendMsgForPointer(STATUS.ENABLED);

                const { expandView } = reduxStore.getState().commonReducer;
                const { pointerOn } = reduxStore.getState().livePointer;

                // Dual stream handling - Agent only, on expand view
                if (dualStreamEnabled() && GLOBAL_MEETING_DATA.isAgent && expandView && !pointerOn) {
                    LogFirebase("AutoLivePointer", "ocr_exit_dual_stream_restart", { expandView, isAgent: true });
                    livePointerService.checkPointerStartOnMarkupOcrExitForDualStream();
                }

                // Single stream with screenshare - use auto pointer pattern
                if (!dualStreamEnabled() && (isLocalUserScreenSharing || isOpponentUserScreenSharing)) {
                    LogFirebase("AutoLivePointer", "ocr_exit_single_stream_screenshare", {
                        isLocalUserScreenSharing,
                        isOpponentUserScreenSharing,
                    });
                    if (pointerOn) {
                        livePointerService.turnOffLivePointer();
                    }
                    // Small delay to ensure pointer is fully turned off before restarting
                    // Note: autoPointerOnForSingleStream already sends ON data track, no need for sendDataTrackForStatusAuto
                    setTimeout(() => {
                        livePointerService.autoPointerOnForSingleStream();
                    }, 300);
                }

                // Single stream with video (local OR remote) - fallback auto-start
                if (!dualStreamEnabled() && !isLocalUserScreenSharing && !isOpponentUserScreenSharing && isAnyVideoAvailable) {
                    LogFirebase("AutoLivePointer", "ocr_exit_single_stream_video", { isAnyVideoAvailable });
                    livePointerService.autoStartLivePointerAfterMarkupOCR("after_ocr_exit");
                }
            } else {
                LogFirebase("AutoLivePointer", "ocr_exit_no_video_available", {
                    myVideoON: CALL_DATA.myVideoON,
                    myscreenShareON: CALL_DATA.myscreenShareON,
                    isAnyVideoAvailable,
                });
            }
        });
        // reset Drawing flags
        this.resetDrawingState();
        zoomService.resetZoomLevelOnExitView(); // Reset a Zoom level on exit OCR for only web devices(in dual stream(expanded view))
    };

    sendOCRDataInEndCall = () => {
        if (GLOBAL_MEETING_DATA.isAgent) {
            if (
                PublicVariables.featureFlag.SHOWMEOCR == ENABLED &&
                PublicVariables.featureFlag.SHOWMESAVEOCRTXT == ENABLED &&
                this.extractTextList.length > 0
            ) {
                LogFirebase("Auto_save_text_on_endcall", "OCR", "");
                chatService.sendTxtFileToServer("OCR", this.extractTextList);
            }
        }
    };

    // download image and render image on canvas function
    OCRstartOppoScreen = (msg) => {
        const extractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;
        //if prepare view exist or new user joins ongoing call
        if (
            extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW ||
            (!isEmpty(msg.for_new_joinee) && extractTextInprogress !== EXTRACT_TEXT_VIEW.OCR_VIEW)
        ) {
            //// utility.removeSidebarZindex();
            this.closeAllModel();
            let imgurl = msg.image_url;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", imgurl, true);
            xhr.send();
            xhr.responseType = "blob";
            this.OCROrientation = navigatorService.getOrientation();
            xhr.onload = (event) => {
                if (xhr.status === 200) {
                    console.log("success downloading ocr image");
                    LogFirebase("OCR", "image_downloading_status", "DOWNLOADED");
                    // blob format file in response
                    const blobfile1 = xhr.response;
                    let canfile1 = new File([blobfile1], "callimage.jpeg", { type: "image/jpeg" });
                    console.log(canfile1);
                    const ocrCanvasEle = document.getElementById("outocrcanvas");
                    if (ocrCanvasEle) ocrCanvasEle.style.display = "block";
                    this.ocrCanvas = new fabric.Canvas("outocrcanvas");
                    this.renderImageForOCR(canfile1);
                }
            };
            // event triggered if download fails
            xhr.onerror = (e) => {
                // need to handle retry and download image pop up.
                reduxStore.dispatch(setDownloadImageFailed(true));
                console.log("Error " + e.target.status + " occurred while receiving the document.");
                LogFirebase("OCR", "image_downloading_status", "FAILED");
            };
        }
    };

    /**when streaming user receives - cancel the markup, status:7 */
    cancelMarkUpOCRPreparing = (type) => {
        const isMarkupInprogress = reduxStore.getState().markup.markupInprogress;
        const isExtractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;
        if (isExtractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW || isMarkupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
            let abortImageRequestButton = document.getElementById("abortImageRequest"); // need to handle this thing for Markup also
            if (abortImageRequestButton) {
                this.markupOCRCancelled = true;
                abortImageRequestButton.click();
            }
        }

        if (
            isMarkupInprogress === MARKUP_VIEW.START_MARKUP_VIEW ||
            reduxStore.getState().markup.arMarkupLiveStream === AR_MARKUP_VIEW.START_MARKUP_VIEW
        ) {
            markupService.toggleannotationdiv(false, false, true, true);
        }
        if (isExtractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW) {
            this.exitocrcanvas(false, true);
        }
        this.hideMarkupOCRAndShowMsg(type, type.toLowerCase() + "_cancelled");
        LogFirebase(type, "prepareView_cancel_received_by", CALL_DATA.localIdentity);
    };

    handleOCRRequestToStreamingUser = () => {
        if (PublicVariables.featureFlag?.SHOWMEOCR === ENABLED) {
            LogFirebase("OCR", "received_msg", "Agent Started Extract Text");
            // If user stream is and on a mobile device, disable pinch zoom
            if (PublicVariables.isMobile) {
                zoomService.disablePinchZoom(); // disable pinch zoom browser for local user
            }
            if (isLocalUserStreaming()) {
                this.onStartPrepareView("OCR");
                this.startmyscreenocr();
            }
        }
    };

    showExitMarkUpOCRToast = (type, idenity) => {
        const partiIndex = getParticipantIndex(idenity);
        const txt = partiIndex + " " + Localize[PublicVariables.currentLanguageObj?.languageCode][type.toLowerCase() + "_exit"];
        CustomToast.info(txt);
    };

    handleUploadImageStart = () => {
        LogFirebase("OCR", "received_msg_image_uploading_status", "UPLOADING");
        this.onStartPrepareView("OCR");
        if (GLOBAL_MEETING_DATA.isGuest) {
            this.checkUploadTimeout("OCR"); //when agent is streaming
        }
    };

    handleUploadImageComplete = (msg, extractTextInprogress) => {
        if (extractTextInprogress !== EXTRACT_TEXT_VIEW.OCR_VIEW) {
            // If already OCR is inprogess then no need to again process
            LogFirebase("OCR", "received_msg_image_uploading_status", "UPLOADED");
            this.ocrImgURL = msg.image_url;
            reduxStore.dispatch(
                setOppoDetails({
                    deviceType: msg.device_type,
                    oppOrientation: msg.orientation,
                    lat: msg.lat,
                    long: msg.long,
                })
            );
            this.onStartPrepareView("OCR");
            this.OCRstartOppoScreen(msg); // if user is new joinee/ aready joined
        }
    };

    handleStopOCR = (msg) => {
        LogFirebase("OCR", "received_msg_stopped_OCR", "Agent stopped OCR");
        if (GLOBAL_MEETING_DATA.isAgent) {
            this.showExitMarkUpOCRToast("OCR", msg.identity);
        }
        this.onExitPrepareView(true);
        this.exitocrcanvas(true);
    };

    handleOCRRequestFromStreamingUser = (msg) => {
        if (PublicVariables.featureFlag?.SHOWMEOCR !== ENABLED || msg.identity === CALL_DATA.localIdentity) {
            return;
        }
        const { dataTrackStatus } = this;
        const { extractTextInprogress } = reduxStore.getState().extractText;
        switch (msg.status) {
            case dataTrackStatus.uploadImageStart: // capture image inprogress
                this.handleUploadImageStart();
                break;
            case this.dataTrackStatus.uploadImageComplete: // image uploaded, ready to download
                this.handleUploadImageComplete(msg, extractTextInprogress);
                break;
            case this.dataTrackStatus.stopOCR: // stop OCR
                this.handleStopOCR(msg);
                break;
            case this.dataTrackStatus.cancelOCR: //request to cancel OCR
                this.cancelMarkUpOCRPreparing("OCR");
                break;
            case this.dataTrackStatus.uploadImageFail: //image to perform the markup - upload failed
                this.hideMarkupOCRAndShowMsg("OCR", msg.body);
                break;
        }
    };

    handleNewJoineeForOCR = () => {
        /* if new participant joins,if ocr is on,agent will send noti. to show view of OCR */
        if (reduxStore.getState().extractText.extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW) {
            const { deviceType, oppOrientation } = reduxStore.getState().commonReducer.OppoDetails;
            const msg = {
                notification_type: NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT,
                status: this.dataTrackStatus.uploadImageComplete,
                identity: CALL_DATA.localIdentity,
                image_url: this.ocrImgURL,
                device_type: deviceType,
                orientation: oppOrientation,
                for_new_joinee: "1",
            };
            console.log("OppoDetails_handleNewJoineeForOCR_msg", msg);

            sendDataTrack(msg);
        }
    };

    //  /* ---------------- Cancels downloading markup image ---------------  */
    cancelDownload = () => {
        reduxStore.dispatch(setDownloadImageFailed(false));
        if (GLOBAL_MEETING_DATA.isAgent) {
            //// $('.modal-backdrop').remove();
            //// $("body").removeClass("modal-open");
            const isMArkupInprogress = reduxStore.getState().markup.markupInprogress;
            if (isMArkupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
                markupService.toggleannotationdiv(false, false, true);
            }
            const isextractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;
            if (isextractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW) {
                this.exitocrcanvas();
            }
        }
    };

    // /* ---------------- Retry downloading markup image ---------------  */
    retryDownload = function () {
        reduxStore.dispatch(setDownloadImageFailed(false));
        //// $('.modal-backdrop').remove();
        //// $("body").removeClass("modal-open");
        const isMarkupInprogress = reduxStore.getState().markup.markupInprogress;
        if (isMarkupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
            let imgObj = { image_url: markupService.annImgURL };
            markupService.startOppoScreen(imgObj);
        }
        const isextractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;
        if (isextractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW) {
            let imgObj = { image_url: this.ocrImgURL };
            this.OCRstartOppoScreen(imgObj);
        }
    };
}

export default new ExtractTextService();
